import type { FaireProductEntity } from "../../entity_types/product";

export const p_q2jdea682m: FaireProductEntity = {
  token: "p_q2jdea682m",
  type: "product",
  name: "5 Piece Gift Set",
  brandToken: "b_cw5lqh1hd4",
  brandName: "Simplified Soap",
  imageUrl:
    "https://cdn.faire.com/fastly/f2d5fe830f3bc7a9da4da0255f8566c67a76b8b89e9f1c86f0e73027b4906c1a.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/4c41e27d6821cc062b415572ed374f4e62f466f8ed76f442fe48b4828446fdf1.png",
    "https://cdn.faire.com/fastly/4c779196ecd53c50dc3f6b163820eeb92446eb85c8fa359efde542f191489996.png",
    "https://cdn.faire.com/fastly/19bc4e2bc7177c4d4b823f5a7aa53aa3d24949f083e5e021d7f366f9de4f5173.png",
    "https://cdn.faire.com/fastly/7ec859d5ce012fc21a81ee4a02c4ca691c675db4425b9a0b1d6a00fe8c169468.jpeg",
    "https://cdn.faire.com/fastly/6f774892972074a621218385ff541c9d77e4e38e1b0106c77f818c005ab6a9a6.jpeg",
  ],
  priceDollars: 11,
  description:
    "This product was designed to give you an opportunity to try 5 of our best-selling products in the fragrance of your choice.\nThese sets also make your gift-giving easier. They're perfect for birthday, holiday, or hostess gifts.\nWe carry this set in all of our fragrances!\n\n𝐈𝐧𝐜𝐥𝐮𝐝𝐞𝐝 𝐢𝐧 𝐭𝐡𝐞 𝐬𝐞𝐭:\n• 2oz Goat Milk Lotion\n• 2oz Body Wash\n• 2oz Exfoliating Body Polish\n• 2.5oz bar of Goat Milk Soap\n• 2oz Salt Sample",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:54:53.099Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
